export default "__VITE_ASSET__B0Vr0ypV__"